import { CheckoutHeader } from "@aitisal/ui/common/CheckoutHeader";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import AppLayout from "../../components/AppLayout";
import CheckoutFooter from "../../components/Footer/CheckoutFooter";
import { useRestuarantDetails } from "../../stores/stores";
import { useBrandingConfig } from "../../utils/brandingConfig";
import CheckOut from "../../screens/checkout";

export const Route = createFileRoute("/c/checkout")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { restaurant } = useRestuarantDetails();
  const brandingConfig = useBrandingConfig();

  return (
    <AppLayout>
      <CheckoutHeader
        logoSrc={brandingConfig.logo}
        logoAlt={brandingConfig.title}
        onLogoClick={() => {
          navigate({ to: "/c", search: (prev: any) => prev });
        }}
        whatsappNumber={restaurant?.phone || brandingConfig.phoneNumber || ""}
      />
      <CheckOut />
      <CheckoutFooter />
    </AppLayout>
  );
}
